import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  LocationOnOutlined,
  StoreOutlined,
  CodeOutlined,
} from "@mui/icons-material";

import { useMerchantDetailContext } from "contexts/MerchantDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

const MerchantBasicDetail = () => {
  const { merchantDetail, loadingMerchant } = useMerchantDetailContext();

  return !loadingMerchant ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <StoreOutlined color="primary" />}
            title="Merchant Name"
            subtitle={merchantDetail?.merchantName || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <CodeOutlined color="primary" />}
            title="Merchant Code"
            subtitle={merchantDetail?.merchantCode || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Location"
            subtitle={merchantDetail?.location || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Merchant Type"
            subtitle={merchantDetail?.merchantType || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={merchantDetail?.active} />
                </InformationTile>
              </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default MerchantBasicDetail;